import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MenuItem } from '../../services/menu.service';
import { UserProfileService } from '../../services/user-profile.service';
import { UserProfileInterface } from '../../interfaces/user-profile.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-shared-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatListModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatButtonModule
  ],
  templateUrl: './shared-sidebar.html',
  styleUrl: './shared-sidebar.scss'
})
export class SharedSidebar implements OnInit, OnDestroy {
  @Input() menuItems: MenuItem[] = [];
  @Input() currentRoute: string = '';
  @Output() menuItemClick = new EventEmitter<MenuItem>();

  private _userProfileService = inject(UserProfileService);
  private _destroy$ = new Subject<void>();

  userProfile: UserProfileInterface | null = null;
  loading = false;
  error: string | null = null;

  ngOnInit(): void {

      this.loadUserProfile();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  loadUserProfile(): void {
    this.loading = true;
    this.error = null;

    this._userProfileService.getUserProfile()
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response) => {

          this.userProfile = response;
          this.loading = false;
        },
        error: (error) => {
          console.error('Erro ao carregar perfil do usuário:', error);
          this.error = 'Erro ao carregar dados do usuário';
          this.userProfile = null;
          this.loading = false;
        }
      });
  }

  onMenuItemClick(item: MenuItem) {
    this.menuItemClick.emit(item);
  }

  isItemSelected(item: MenuItem): boolean {
    if (!item.route) return false;
    return item.route === this.currentRoute;
  }

  isExternalLink(item: MenuItem): boolean {
    return !!item.externalUrl;
  }

  getDisplayName(): string {
    if (this.userProfile?.PF_NOME) {
      return this.userProfile.PF_NOME;
    }
    return 'Aluno(a)';
  }

  getDisplayEmail(): string {
    if (this.userProfile?.PF_EMAIL) {
      return this.userProfile.PF_EMAIL;
    }
    return 'aluno@unicamp.br';
  }

  getDisplayPhoto(): string {
    if (this.userProfile?.photoUrl) {
      return this.userProfile.photoUrl;
    }
    return '';
  }
}
